import Typography from 'components/gruenland/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import { ShippingMethod } from 'types/entity/cart';
import { Order } from 'types/entity/order';
import useOrderInfoData from '../hooks/useOrderInfoData';

type ThankYouOrderInfoProps = {
  shipToName?: string;
  order?: Order;
  shippingMethods: ShippingMethod[];
  orderNumberPending?: boolean;
};

const ThankYouOrderInfo: React.FC<ThankYouOrderInfoProps> = ({
  shipToName,
  order,
  shippingMethods,
  orderNumberPending,
}) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const loading = !order;

  const { orderNumber, deliveryMethod, shippingAddress } = useOrderInfoData({ order, shippingMethods });

  const orderInfo = [
    {
      label: formatMessage({ id: 'order.number', defaultMessage: 'Numero ordine' }),
      value: orderNumber || '-',
      valueLoading: orderNumberPending,
    },
    {
      label: formatMessage({ id: 'order.deliveryMethod', defaultMessage: 'Metodo di consegna' }),
      value: deliveryMethod || '-',
    },
    {
      label: formatMessage({ id: 'order.deliveryTo', defaultMessage: 'Consegna a' }),
      value: shipToName || '',
      subValue: shippingAddress || '-',
    },
  ];

  return (
    <div className="grid gap-4 border-b border-neutral-400 py-6 md:gap-6 lg:py-9">
      {orderInfo.map(({ label, value, subValue, valueLoading }, index) => (
        <div key={index}>
          <div className="flex flex-wrap gap-[5px] md:gap-0">
            <div className="md:w-[136px]">
              <Typography
                className="w-fit text-[14px] leading-loose text-secondary-black md:text-[16px]"
                asSkeleton={loading}
              >
                {label + ':'}
              </Typography>
            </div>
            <Typography
              className="text-[14px] font-medium leading-loose text-primary-black md:text-[16px]"
              asSkeleton={loading || valueLoading}
            >
              {value}
            </Typography>
          </div>
          {subValue && (
            <Typography
              className="mt-1 w-fit whitespace-pre-line text-[14px] leading-loose text-primary-black md:ml-[136px] md:text-[16px]"
              asSkeleton={loading}
            >
              {subValue}
            </Typography>
          )}
        </div>
      ))}
    </div>
  );
};

export default ThankYouOrderInfo;
